import { Component, OnInit } from '@angular/core';
import { SharedMaterialModule } from '../../shared-material.module';
import { CommonModule } from '@angular/common';
import { MatTabChangeEvent } from '@angular/material/tabs';

interface Producto {
  nombre: string;
  imagen: string;
  descripcion: string;
  precio: string;
  tipo: string;
}

@Component({
  selector: 'app-productos',
  standalone: true,
  imports: [CommonModule, SharedMaterialModule],
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.css']
})
export class ProductosComponent implements OnInit {
onTabChange($event: MatTabChangeEvent) {
throw new Error('Method not implemented.');
}
  productos: Producto[] = [
    { nombre: 'Playera React', imagen: 'assets/playera.jpg', descripcion: 'Playera con diseño React', precio: '$250', tipo: 'playera' },
    { nombre: 'Gorra Dev', imagen: 'assets/gorra.jpg', descripcion: 'Gorra para desarrolladores', precio: '$180', tipo: 'gorra' },
    { nombre: 'Playera básica', imagen: 'assets/playera2.jpg', descripcion: 'Playera básica sin diseño', precio: '$150', tipo: 'playera' },
    { nombre: 'Gorra clásica', imagen: 'assets/gorra2.jpg', descripcion: 'Gorra clásica', precio: '$130', tipo: 'gorra' }
  ];

  productosFiltrados: Producto[] = [];

  ngOnInit() {
    this.mostrarTodos();
  }

  filtrarProductos(tipo: string) {
    this.productosFiltrados = this.productos.filter(p => p.tipo === tipo);
  }

  mostrarTodos() {
    this.productosFiltrados = this.productos;
  }

  comprarProducto(producto: Producto) {
    alert(`Compraste: ${producto.nombre}`);
  }
}
